import { render, staticRenderFns } from "./EmailVerificationAlert.vue?vue&type=template&id=217e4038&scoped=true&"
import script from "./EmailVerificationAlert.vue?vue&type=script&lang=ts&"
export * from "./EmailVerificationAlert.vue?vue&type=script&lang=ts&"
import style0 from "./EmailVerificationAlert.vue?vue&type=style&index=0&id=217e4038&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217e4038",
  null
  
)

export default component.exports